import React from "react";
import Navb from "../../components/navbar/Navb";
import Footer from "../../components/footer/Footer";
import Container from "react-bootstrap/Container";
import "./privacy.css";
const Disclaimer = () => {
  return (
    <>
      <Navb />
      {/* <Container></Container> */}
      <div className="privacyPolicy">
        <Container>
          <div className="whiteHeading">Disclaimer</div>
        </Container>
      </div>
      <div className="privacyCollect">
        <Container>
          <div className="blackHeading" style={{ color: "black" }}>
            No warranty
          </div>
          <div className="blackP" style={{ color: "black" }}>
            Content of this website is for information purpose only. The
            information and materials contained in this site, including text,
            graphics, links or other items - are provided "as-is," "as
            available". Nandi does not warrant the accuracy, adequacy or
            completeness of this information and materials and expressly
            disclaims liability for errors or omissions in this information and
            materials. No warranty of any kind, implied, express or statutory,
            including but not limited to the warranties of infringement of third
            party rights, title, merchantability, fitness for a particular
            purpose and freedom from computer virus, is given in conjunction
            with the information and materials.
          </div>
        </Container>
      </div>
      <div className="privacyGather">
        <Container>
          <div className="whiteHeading">Copyright ©</div>
          <div className="whiteP" style={{ color: "white" }}>
            Copyright in the pages and in the screens displaying the pages, and
            in the information and material therein and in their arrangement, is
            owned by Nandi, unless otherwise indicated.
          </div>
        </Container>
      </div>
      <div className="Security">
        <Container>
          <div className="blackHeading">Trademarks</div>
          <div className="blackP">
            Our logo are registered trademarks and service marks. Nandi may also
            claim trademark and service mark rights in other marks contained in
            the pages.
          </div>
        </Container>
      </div>
      <div className="privacyCollect">
        <Container>
          <div className="blackHeading" style={{ color: "black" }}>
            Use of Information and Materials
          </div>
          <div className="blackP" style={{ color: "black" }}>
            The information and materials contained in these pages - and the
            terms, conditions, and descriptions that appear - are subject to
            change and can be used for information purpose only and cannot be
            the basis of forming any opinion. Not all products and services are
            available in all geographic areas. Your eligibility for particular
            products and services is subject to final Nandi determination and
            acceptance.
          </div>
        </Container>
      </div>
      <Footer />
    </>
  );
};

export default Disclaimer;
